module.exports = __webpack_public_path__ + "img/이태원 스테이크.ebe16cb5.png";